<template>
  <div>
    <div class="banner innerpageBanner">
<div class="container">
<div class="caption">
<div><h1>最新资讯</h1>
<p>来自勃艮第的最新资讯 </p>
</div>
</div>
</div>

<img src="https://image.insideburgundy.cn/insideburgundy/20190523/60b96a8b64834cc7aeff90bfa956f40e.png" alt="最新资讯" class="cover-image">
</div>

      <div class="container">
        <searchBox  />
        <div class="breadcrumbWrap">
          <div class="breadcrumb" style="padding-top:20px">
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
            <span property="itemListElement" typeof="ListItem">
              <span property="name">最新资讯</span>
              <meta property="position" content="2">
            </span>
          </div>
        </div>
      </div>
    <section class="innerPage">

      <div class="container">
        <rightMenu title="分类"   :menudata='rightListdata' @OnClick='rightClick'/>

        <div class="leftCol">
          <ul class="newsListing r1234">
            <li v-for="item in contentlist" :key='item .id'>
              <div
                class="post-28874 post type-post status-publish format-standard has-post-thumbnail hentry category-just-jasper category-inside-burgundy"
              >
                <h4>
                  <a :href="'#/latestinformation?id='+item.id">{{item.title}}</a>
                  <span>{{item.createTime}}</span>
                </h4>

                <div class="entry">
                  <p>{{item.introduction}}</p>
                </div>

                <div class="readmore">
                  <a :href="'#/latestinformation?id='+item.id">阅读更多</a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ajax from '../ajax';
import searchBox from '../template/search'
import rightMenu from '../template/rightMenu'

export default {
  components:{
    rightMenu,
    searchBox
  },
  data(){
    return {
      contentlist:[],
      rightListdata:{}
    }
  },
  created() {
    ajax.getNewsLaest().then(res=>{
      this.contentlist = res.data
    });
    this.getRightdata()
  },
  methods: {
    getRightdata(){
      ajax.getNewsCategories().then(res=>{
        this.rightListdata = res.data
      })
    },
    rightClick(data){
      if(!data.child&&data.id)
        this.$router.push({path:'/latestinformation',query:{id:data.id}})
    },
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Report.vue